import styles from './MissingStatementsRow.module.scss';
import { formatTooltipDate } from '../../../../../Dashboard/DashboardModules/BankDataTable/components/MissingDaysTooltipContent';
import type { MissingStatementRange } from '../../../../types';

interface MissingStatementsRowProps {
    /** One gap range for this row. Callers with several ranges at the same insertion position
     *  render one MissingStatementsRow per range, stacked — never several ranges through one
     *  instance. */
    missingStatements: MissingStatementRange;
    /** Same depth prop File/Folder rows use, so this row indents to match its account folder. */
    index: number;
}

/**
 * "Missing Statements: <range>" — one row per gap range. Ranges sharing the same computed
 * insertion position (FileTree's `groupGapsByInsertionPosition`) render as separate, stacked
 * MissingStatementsRow instances, never as sibling pills inside one band. Joins File/, FileTree/,
 * Folder/ as a 4th sibling in this exact folder-per-component convention.
 */
const MissingStatementsRow = ({ missingStatements, index }: MissingStatementsRowProps) => {
    // The indentation depth term lives in padding-left, not marginLeft, so the band's own grey
    // fill/border stay full-width at every nesting level.
    const depthOffset = `${(index - 1) * 1.25}rem`;

    return (
        <div className={styles.MissingStatementsRow} style={{ '--depth-offset': depthOffset } as React.CSSProperties}>
            <span className={styles.Pill}>
                Missing Statements: {formatTooltipDate(missingStatements.from)} –{' '}
                {formatTooltipDate(missingStatements.to || missingStatements.from)}
            </span>
        </div>
    );
};

export default MissingStatementsRow;
